import { formatCurrencyValue } from "@/lib/utils";
import { useGetAllBankConnections } from "@/queries/bank-connections/get-all";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const AccountBalanceCard = () => {
  const { bankConnections } = useGetAllBankConnections();

  const { t } = useTranslation();

  const totalBalance = useMemo(() => {
    return bankConnections.reduce((acc, connection) => {
      return (
        acc +
        connection.accounts
          .filter((account) => account.currency === "EUR")
          .reduce((acc, account) => {
            return acc + account.balance;
          }, 0)
      );
    }, 0);
  }, [bankConnections]);

  const numberOfAccounts = useMemo(() => {
    return bankConnections.reduce((acc, connection) => {
      return (
        acc +
        connection.accounts.filter((account) => account.currency === "EUR")
          .length
      );
    }, 0);
  }, [bankConnections]);

  if (numberOfAccounts === 0) return null;

  return (
    <div className="bg-white px-3 min-w-60 flex items-center ml-auto h-full">
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col">
          <div className="flex items-center gap-1">
            <span className="text-xs font-medium text-gray-600">
              {t("account-balance.saldo", {
                count: numberOfAccounts,
              })}
            </span>
          </div>
          <span className="text-xl font-semibold text-gray-900">
            {formatCurrencyValue(totalBalance)} €
          </span>
        </div>
      </div>
    </div>
  );
};
